import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import RedFlagType from '../../entities/redFlagType';
import RedFlag from '../../entities/redFlag';

/*
 * Delete/nullify anywhere this redFlagType is used in other entities
 *
 * @param {RedFlagType} redFlagType
 */
export function deleteRedFlagType(redFlagType: RedFlagType, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = redFlagType.id;
    }
    /* Simple delete usages */
        
    store.getState().redFlags
        .getMappingFor('redFlagTypeId', redFlagType.id)
        .filter(redFlagTemp => redFlagTemp.status !== 'D')
        .forEach(redFlagTemp => {
            const _redFlag = redFlagTemp.clone();
            _redFlag.status =  'D';
            _redFlag.addedOn = newHRTimestamp();
            _redFlag.addedBy = getCurrentUserId();
            _redFlag.importSource = targetImportSource;
            _redFlag.importId = mergeId;

            store.dispatch(Actions.RedFlagActions.saveRedFlagQueue(_redFlag));
        });

    /* Remove the actual redFlagType */
    redFlagType.status = 'D';
    redFlagType.addedOn = newHRTimestamp();
    redFlagType.addedBy = getCurrentUserId();
    redFlagType.importSource = targetImportSource;
    redFlagType.importId = mergeId;
    store.dispatch(Actions.RedFlagTypeActions.removeRedFlagTypeQueue(redFlagType));
    
}

/*
 * Replace anywhere this redFlagType is used in other entities.
 *
 * @param {RedFlagType} redFlagType
 * @param {RedFlagType} replaceWith
 * @return {RedFlagType} - RedFlagType will have refs stripped away
 */
export function replaceRedFlagType(redFlagType: RedFlagType, replaceWith: RedFlagType, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = redFlagType.id;
    }
    /* Simple replace usages */
        
    store.getState().redFlags
        .getMappingFor('redFlagTypeId', redFlagType.id)
        .filter(redFlagTemp => redFlagTemp.status !== 'D')
        .forEach(redFlagTemp => {
            const _redFlag = redFlagTemp.clone();
            _redFlag.status =  'U';
            _redFlag.addedOn = newHRTimestamp();
            _redFlag.addedBy = getCurrentUserId();
            _redFlag.importSource = targetImportSource;
            _redFlag.importId = mergeId;

            _redFlag.redFlagTypeId = replaceWith.id;
            store.dispatch(Actions.RedFlagActions.saveRedFlagQueue(_redFlag));
        });

    return redFlagType;
}

/*
 * Determine the impact of deleting this redFlagType from other entities
 *
 * @param {RedFlagType} redFlagType
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactRedFlagType(redFlagType: RedFlagType) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const redFlagRedFlagTypeIdImpact = state.redFlags
          .getMappingFor('redFlagTypeId', redFlagType.id)
          .filter(redFlag => redFlag.status !== 'D');

    redFlagRedFlagTypeIdImpact.forEach(() => impacts.push('redFlags'));

    return util.countDistinct(impacts);
}